import React from 'react';

const Live = ({ lastUpdate }) => (
  <span className="live" title="Actualisation automatique toutes les 15 secondes">
    En direct{lastUpdate && ` · ${lastUpdate.toLocaleTimeString('fr-FR')}`}
  </span>
);

export default Live;
